import React from "react";
import ProtectedRoute from "routes/ProtectedRoute";

export const studioRoutes = [
  {
    path: "studio",
    children: [
      {
        path: ":presentationId/:eventId?",
        lazy: async () => {
          const mod = await import("views/Admin/studio/studio-edit");
          const StudioEdit = mod.StudioEdit;

          return {
            Component: () => (
              <ProtectedRoute>
                <StudioEdit />
              </ProtectedRoute>
            ),
          };
        },
      },
    ],
  },
];
